import { CabeceraTable } from "../../../../components/Table/CabeceraTable";
import { IColumn, ICommandBarItemProps } from "@fluentui/react";
import { useBoolean } from "@fluentui/react-hooks";
import { useTableDispositivoAsignados } from "../../../../hooks/TablasHooks/useTableDispositivoAsignados";
import IconHelper from "../../../../utils/helpers/iconHelper";
import { PanelFilterDispositivoAsignados } from "./PanelFilterDispositivoAsignados";
import { TableBase2 } from "../../../../components/Table/TableBase2";
import { PaginationFooterC } from "../../../../components/PaginationFooter/PaginationFooterC";
import ReporteAsignados from "../ReporteDspAsignados";
import { useEffect } from "react";

export const DispositivosAsignados = () => {
  const {
    itemsTable,
    _onkeyUpSearchDispositivo,
    searchBoxRefTable,
    onChangeComboBox,
    limpiarFiltro,
    loading,
    paginacion,
    _onSelectDate,
    actualizarTabla,
    filterFechas,
    filter,
    filterReporte,
    onChangeSkip,
    postTablaDispositivoAsignados
  } = useTableDispositivoAsignados();

  const [isOPenPanel, { setTrue: openPanel, setFalse: dismissPanel }] =
    useBoolean(false);
  const [
    isOPenPanelReporte,
    { setTrue: openPaneReportel, setFalse: dismissPanelReporte },
  ] = useBoolean(false);

  useEffect(() => {
      postTablaDispositivoAsignados();
    }, []);

  const column: IColumn[] = [
    {
      key: "persona",
      name: "Persona",
      fieldName: "persona",
      minWidth: 150,
      maxWidth: 150,
      isResizable: true,
    },
    {
      key: "nroDoi",
      name: "DNI",
      fieldName: "nroDOI",
      minWidth: 80,
      maxWidth: 80,
      isResizable: false,
      onRender: (item: any) => (
        <span style={{ fontWeight: "bold", fontSize: 12 }}>{item.nroDOI}</span>
      ),
    },
    {
      key: "email",
      name: "Email",
      fieldName: "email",
      minWidth: 150,
      maxWidth: 150,
      isResizable: true,
    },
    {
      key: "guardia",
      name: "Guardia",
      fieldName: "guardia",
      minWidth: 50,
      maxWidth: 50,
      isResizable: true,
    },
    {
      key: "area",
      name: "Área",
      fieldName: "area",
      minWidth: 150,
      maxWidth: 150,
      isResizable: true,
    },
    {
      key: "modelo",
      name: "Modelo Equipo",
      fieldName: "modelo",
      minWidth: 150,
      maxWidth: 150,
      isResizable: true,
    },
    {
      key: "fechaEntrega",
      name: "Fecha Entrega",
      fieldName: "fechaEntrega",
      minWidth: 90,
      maxWidth: 90,
      isResizable: true,
    },
    {
      key: "horaEntrega",
      name: "Hora Entrega",
      fieldName: "horaEntrega",
      minWidth: 90,
      maxWidth: 90,
      isResizable: true,
    },
    {
      key: "serie",
      name: "Serie",
      fieldName: "serie",
      minWidth: 80,
      maxWidth: 80,
      isResizable: true,
      isMultiline: true,
    },
    {
      key: "codigo",
      name: "Código",
      fieldName: "codigo",
      minWidth: 50,
      maxWidth: 50,
      isResizable: true,
    },

    // {
    //   key: "estado",
    //   name: "Estado",
    //   fieldName: "alertaDevolucion",
    //   minWidth: 90,
    //   maxWidth: 90,
    //   isResizable: true,
    //   onRender: (item: any) => {
    //     switch (item.alertaDevolucion) {
    //       case 1:
    //         return (
    //           <>
    //             <TooltipButtom
    //               color="green"
    //               iconName="VerifiedBrandSolid"
    //               textoToolTip="El tiempo de pertenecia de menor a 9 días"
    //             />
    //           </>
    //         );
    //       case 2:
    //         return (
    //           <>
    //             <TooltipButtom
    //               color="#d4ad00"
    //               iconName="WarningSolid"
    //               textoToolTip="Se Encuentra en el plazo de entrega"
    //             />
    //           </>
    //         );

    //         break;
    //       case 3:
    //         return (
    //           <>
    //             <TooltipButtom
    //               color="red"
    //               iconName="BlockedSiteSolid12"
    //               textoToolTip="Ya cumplio mas de 10 días la tablet en su poder"
    //             />
    //           </>
    //         );

    //         break;
    //       default:
    //         break;
    //     }
    //   },
    // },
  ];
  const rigth_items: ICommandBarItemProps[] = [
    {
      ...IconHelper.ICON_FILTER,
      onClick: () => { openPanel(); },
      text: 'Buscar'
    },
    {
      ...IconHelper.ICON_EXCEL,
      text: "Descargar Reporte",
      onClick: () => {
        openPaneReportel();
      },
    },
  ];
  const left_items: ICommandBarItemProps[] = [
    {
      ...IconHelper.ICON_RELOAD,
      onClick: () => {
        actualizarTabla();
      },
    },
  ];
  return (
    <div>
      <div className="ms-Grid-row" style={{ marginTop: "10px" }}>
        <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
          <CabeceraTable
            placeholder="Buscar Por Código"
            componentRef={searchBoxRefTable}
            Titulo="Dispositivo"
            SubTitulo="Dispositivo Entregados (No devueltas)"
            onKeyUp={_onkeyUpSearchDispositivo}
          />
        </div>
      </div>
      <br />
      <TableBase2
        leftBar={left_items}
        rigthBar={rigth_items}
        data={itemsTable}
        column={column}
        isLoading={loading}
        footerPagination={
          <PaginationFooterC
            paginacion={paginacion}
            onChangePagina={(e) => {
              onChangeSkip(e);
            }}
          />
        }
      />

      <PanelFilterDispositivoAsignados
        filter={filter}
        filterReporte={filterReporte}
        filterFechas={filterFechas}
        isOpen={isOPenPanel}
        onDismiss={dismissPanel}
        limpiarFiltro={limpiarFiltro}
        onSelectDate={_onSelectDate}
        onChangeComboGuardia={onChangeComboBox}
        buscar={postTablaDispositivoAsignados}
      />
      <ReporteAsignados
        isOpen={isOPenPanelReporte}
        onDismiss={dismissPanelReporte}
      />
    </div>
  );
};
